import ApiService from "../../api/api.service";
import { GET_RETIREMENT_FORM_DETAIL, GET_PPF_FORM, SAVE_RETIREMENT_FORM_DETAIL, EDIT_RETIREMENT_FORM, 
UPDATE_RETIREMENT_FORM, GET_EPF_FORM, GET_NPS_FORM, GET_AS_FORM, GET_POLICY_NAME, GET_MIS_FORM} from "../actions.type";

const getDefaultRetirementState = () => {
	return {
		retirementFormDetail: {},
		PpfForm: {},
		saveRetirementFormDetail: {},
		bankPostData: {},
		editRetirementForm: {},
		updateRetirementForm: {},
		epfForm: {},
		npsForm: {},
		asForm: {},
		misForm: {},
		policyName: {},
	}
};

const state = getDefaultRetirementState();

const getters = {

	getRetirementFormDetail(state) {
		return state.retirementFormDetail;
	},
	getPpfForm(state) {
		return state.PpfForm;
	},
	getSaveRetirementFormDetail(state) {
		return state.saveRetirementFormDetail;
	},
	getBankPostData(state) {
		return state.bankPostData;
	},
	getEditRetirementForm(state) {
		return state.editRetirementForm;
	},
	getUpdateRetirementForm(state) {
		return state.updateRetirementForm;
	},
	getEpfForm(state) {
		return state.epfForm;
	},
	getNpsForm(state) {
		return state.npsForm;
	},
	getAsForm(state) {
		return state.asForm;
	},
	getMisForm(state) {
		return state.misForm;
	},
	getPolicyName(state) {
		return state.policyName;
	},
};

const mutations = {

	setRetirementFormDetail (state, data) {
		state.retirementFormDetail = data
	},
	setPpfForm (state, data) {
		state.PpfForm = data
	},
	setSaveRetirementFormDetail (state, data) {
		state.saveRetirementFormDetail = data
	},
	setBankPostdata(state, data) {
		state.bankPostData = data
	},
	setEditRetirementForm(state, data) {
		state.editRetirementForm = data
	},
	setUpdateRetirementForm(state, data) {
		state.updateRetirementForm = data
	},
	setEpfForm (state, data) {
		state.epfForm = data
	},
	setNpsForm (state, data) {
		state.npsForm = data
	},
	setAsForm (state, data) {
		state.asForm = data
	},
	setMisForm (state, data) {
		state.misForm = data
	},
	setPolicyName (state, data) {
		state.policyName = data
	},
};


const actions = {

	[GET_RETIREMENT_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setRetirementFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_PPF_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setPpfForm',data);
				data.data.master_data.forEach(element => {

					if (element.AccountType) {
						context.commit('setBankPostdata',element.AccountType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[SAVE_RETIREMENT_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSaveRetirementFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[EDIT_RETIREMENT_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEditRetirementForm',data);
				data.data.master_data.forEach(element => {

					if (element.AccountType) {
						context.commit('setBankPostdata',element.AccountType);
					}
					if (element.SchemeAccountType) {
						context.commit('setBankPostdata',element.SchemeAccountType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[UPDATE_RETIREMENT_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUpdateRetirementForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_EPF_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEpfForm',data);
				data.data.master_data.forEach(element => {

					if (element.AccountType) {
						context.commit('setBankPostdata',element.AccountType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_NPS_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setNpsForm',data);
				data.data.master_data.forEach(element => {

					if (element.AccountType) {
						context.commit('setBankPostdata',element.AccountType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_AS_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setAsForm',data);
				data.data.master_data.forEach(element => {

					if (element.AccountType) {
						context.commit('setBankPostdata',element.AccountType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_MIS_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setMisForm',data);
				data.data.master_data.forEach(element => {

					if (element.SchemeAccountType) {
						context.commit('setBankPostdata',element.SchemeAccountType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_POLICY_NAME](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setPolicyName',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
};

export default {
	getters,
	actions,
	mutations,
	state
}